export const LAST_UPDATED = '_lastUpdated';

export const RESEARCH_STUDY = 'ResearchStudy';

export enum resourceStatuses {
  ACTIVE = 'active',
  DRAFT = 'draft',
  RETIRED = 'retired',
}
